function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "--copy-4",
  transform: "translate(-801.000000, -960.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "video-player-copy",
  transform: "translate(801.000000, 960.000000)"
}, React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#FFFFFF",
  x: 1.11392405,
  y: 2.22222222,
  width: 45.6708861,
  height: 66.6666667
}), React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#A4C2F7",
  x: 41.2151899,
  y: 2.22222222,
  width: 45.6708861,
  height: 66.6666667
}), React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#E3E7F2",
  x: 5.56962025,
  y: 2.22222222,
  width: 75.7468354,
  height: 66.6666667
}), React.createElement("polygon", {
  id: "Shape",
  fill: "#7FACFA",
  points: "37.8734177 45.5555556 37.8734177 34.9306466 37.8734177 24.4444444 54.5822785 35"
}), React.createElement("path", {
  d: "M49.0126582,34.5474721 L37.934129,27.7777778 C37.9255385,27.8176758 37.9250126,27.861614 37.9171234,27.9018487 C37.9251879,28.248978 37.9286942,28.5957706 37.9185259,28.9503071 C37.7977336,29.6960795 37.9209803,30.4595282 38.2709098,31.1354371 C38.6909654,31.6951873 38.6187355,32.4665483 38.1013798,32.9453241 C38.2996615,34.1117929 38.4321999,35.2876891 38.4982938,36.4679624 C38.5317791,38.018765 38.4560428,39.5700726 38.2716111,41.1111111 L49.0126582,34.5474721 Z",
  id: "Shape",
  fill: "#A4C2F7"
}), React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#7FACFA",
  x: 71.2911392,
  y: 2.22222222,
  width: 15.5949367,
  height: 16.6666667
}), React.createElement("g", {
  id: "Group",
  transform: "translate(5.569620, 1.111111)",
  fill: "#A4C2F7"
}, React.createElement("rect", {
  id: "Rectangle-path",
  x: 65.1040623,
  y: 0.135324232,
  width: 10.5896475,
  height: 16.5704778
}), React.createElement("rect", {
  id: "Rectangle-path",
  x: 0.0531256086,
  y: 0.135324232,
  width: 10.5896475,
  height: 16.5704778
}), React.createElement("rect", {
  id: "Rectangle-path",
  x: 0.0531256086,
  y: 33.2764505,
  width: 10.5896475,
  height: 16.5704778
})), React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#7FACFA",
  x: 71.2911392,
  y: 34.4444444,
  width: 15.5949367,
  height: 16.6666667
}), React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#A4C2F7",
  x: 71.2911392,
  y: 34.4444444,
  width: 11.1392405,
  height: 16.6666667
}), React.createElement("g", {
  id: "Group",
  opacity: 0.495647321,
  fill: "#3C5E8F"
}, React.createElement("path", {
  d: "M86.3141053,69.8342647 L1.51435478,69.8342647 C1.11277973,69.8344363 0.727500974,69.6748775 0.443430799,69.3907598 C0.159360623,69.1066422 -6.94481515e-10,68.7214706 -6.94481515e-10,68.3196569 L-6.94481515e-10,1.68017157 C-0.000171540655,1.27852941 0.159360623,0.893186275 0.443430799,0.609068627 C0.727500974,0.32495098 1.11260819,0.165563725 1.51435478,0.165563725 L86.3142768,0.165563725 C86.7158519,0.165392157 87.1011306,0.32495098 87.3852008,0.609068627 C87.669271,0.893186275 87.8286316,1.27835784 87.8286316,1.68017157 L87.8286316,68.3198284 C87.8288031,68.7214706 87.669271,69.1068137 87.3852008,69.3909314 C87.1009591,69.6748775 86.7158519,69.8344363 86.3141053,69.8342647 Z M3.02853801,66.8052206 L84.799922,66.8052206 L84.799922,3.19477941 L3.02853801,3.19477941 L3.02853801,66.8052206 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M37.857154,47.116348 C37.4554074,47.1168627 37.0699571,46.9574755 36.7858869,46.6731863 C36.5018168,46.3890686 36.3424561,46.0035539 36.3427992,45.6017402 L36.3427992,24.3982598 C36.3424561,23.8452941 36.6435088,23.3360784 37.1282807,23.0699755 C37.6130526,22.8038725 38.2041793,22.8232598 38.670425,23.1204167 L55.3274698,33.7221569 C55.764039,34.0004412 56.0283821,34.4822059 56.0283821,35 C56.0283821,35.5177941 55.764039,35.9997304 55.3274698,36.2778431 L38.670425,46.8795833 C38.4271813,47.0339951 38.1451696,47.1160049 37.857154,47.116348 Z M39.3713372,27.1565686 L39.3713372,42.8432598 L51.6933957,35 L39.3713372,27.1565686 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M16.6570448,19.8546078 L1.51435478,19.8546078 C1.11277973,19.8547794 0.727500974,19.6952206 0.443430799,19.4111029 C0.159360623,19.1269853 -6.94481515e-10,18.7418137 -6.94481515e-10,18.34 L-6.94481515e-10,1.68017157 C-0.000171540655,1.27852941 0.159360623,0.893186275 0.443430799,0.609068627 C0.727500974,0.32495098 1.11260819,0.165563725 1.51435478,0.165563725 L16.6572164,0.165563725 C17.0587914,0.165392157 17.4440702,0.32495098 17.7281404,0.609068627 C18.0122105,0.893186275 18.1715711,1.27835784 18.1715711,1.68017157 L18.1715711,18.34 C18.1717427,18.7416422 18.0122105,19.1269853 17.7281404,19.4111029 C17.4440702,19.6952206 17.0587914,19.8547794 16.6570448,19.8546078 Z M3.02853801,16.8255637 L15.1428616,16.8255637 L15.1428616,3.19477941 L3.02853801,3.19477941 L3.02853801,16.8255637 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M16.6570448,36.5146078 L1.51435478,36.5146078 C1.11277973,36.5147794 0.727500974,36.3552206 0.443430799,36.0711029 C0.159360623,35.7869853 -0.000171540655,35.4016422 -6.94481362e-10,35 L-6.94481362e-10,18.3401716 C-0.000171540655,17.9385294 0.159360623,17.5531863 0.443430799,17.2690686 C0.727500974,16.984951 1.11260819,16.8255637 1.51435478,16.8255637 L16.6572164,16.8255637 C17.0587914,16.8253922 17.4440702,16.984951 17.7281404,17.2690686 C18.0122105,17.5531863 18.1715711,17.9383578 18.1715711,18.3401716 L18.1715711,35 C18.1717427,35.4016422 18.0122105,35.7869853 17.7281404,36.0711029 C17.4440702,36.355049 17.0587914,36.5146078 16.6570448,36.5146078 Z M3.02853801,33.4853922 L15.1428616,33.4853922 L15.1428616,19.8546078 L3.02853801,19.8546078 L3.02853801,33.4853922 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M16.6570448,53.1744363 L1.51435478,53.1744363 C1.11277973,53.1746078 0.727500974,53.015049 0.443430799,52.7309314 C0.159360623,52.4468137 -6.94481515e-10,52.0616422 -6.94481515e-10,51.6598284 L-6.94481515e-10,35 C-0.000171540655,34.5983578 0.159360623,34.2130147 0.443430799,33.9288971 C0.727500974,33.6447794 1.11260819,33.4853922 1.51435478,33.4853922 L16.6572164,33.4853922 C17.0587914,33.4852206 17.4440702,33.6447794 17.7281404,33.9288971 C18.0122105,34.2130147 18.1715711,34.5981863 18.1715711,35 L18.1715711,51.6598284 C18.1717427,52.0614706 18.0122105,52.4468137 17.7281404,52.7309314 C17.4440702,53.015049 17.0587914,53.1746078 16.6570448,53.1744363 Z M3.02853801,50.1453922 L15.1428616,50.1453922 L15.1428616,36.5146078 L3.02853801,36.5146078 L3.02853801,50.1453922 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M16.6570448,69.8342647 L1.51435478,69.8342647 C1.11277973,69.8344363 0.727500974,69.6748775 0.443430799,69.3907598 C0.159360623,69.1066422 -6.94481515e-10,68.7214706 -6.94481515e-10,68.3196569 L-6.94481515e-10,51.6598284 C-0.000171540655,51.2581863 0.159360623,50.8728431 0.443430799,50.5887255 C0.727500974,50.3046078 1.11260819,50.1452206 1.51435478,50.1452206 L16.6572164,50.1452206 C17.0587914,50.145049 17.4440702,50.3046078 17.7281404,50.5887255 C18.0122105,50.8728431 18.1715711,51.2580147 18.1715711,51.6598284 L18.1715711,68.3196569 C18.1717427,68.721299 18.0122105,69.1066422 17.7281404,69.3907598 C17.4440702,69.6748775 17.0587914,69.8344363 16.6570448,69.8342647 Z M3.02853801,66.8052206 L15.1428616,66.8052206 L15.1428616,53.1744363 L3.02853801,53.1744363 L3.02853801,66.8052206 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M86.3141053,19.8546078 L71.1712437,19.8546078 C70.7696686,19.8547794 70.3843899,19.6952206 70.1003197,19.4111029 C69.8162495,19.1269853 69.6568889,18.7418137 69.6568889,18.34 L69.6568889,1.68017157 C69.6567173,1.27852941 69.8162495,0.893186275 70.1003197,0.609068627 C70.3843899,0.32495098 70.7694971,0.165563725 71.1712437,0.165563725 L86.3141053,0.165563725 C86.7156803,0.165392157 87.1009591,0.32495098 87.3850292,0.609068627 C87.6690994,0.893186275 87.82846,1.27835784 87.82846,1.68017157 L87.82846,18.34 C87.8286316,18.7416422 87.6690994,19.1269853 87.3850292,19.4111029 C87.1009591,19.6952206 86.7158519,19.8547794 86.3141053,19.8546078 Z M72.6855984,16.8255637 L84.799922,16.8255637 L84.799922,3.19477941 L72.6855984,3.19477941 L72.6855984,16.8255637 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M86.3141053,36.5146078 L71.1712437,36.5146078 C70.7696686,36.5147794 70.3843899,36.3552206 70.1003197,36.0711029 C69.8162495,35.7869853 69.6568889,35.4018137 69.6568889,35 L69.6568889,18.3401716 C69.6567173,17.9385294 69.8162495,17.5531863 70.1003197,17.2690686 C70.3843899,16.984951 70.7694971,16.8255637 71.1712437,16.8255637 L86.3141053,16.8255637 C86.7156803,16.8253922 87.1009591,16.984951 87.3850292,17.2690686 C87.6690994,17.5531863 87.82846,17.9383578 87.82846,18.3401716 L87.82846,35 C87.8286316,35.4016422 87.6690994,35.7869853 87.3850292,36.0711029 C87.1009591,36.355049 86.7158519,36.5146078 86.3141053,36.5146078 Z M72.6855984,33.4853922 L84.799922,33.4853922 L84.799922,19.8546078 L72.6855984,19.8546078 L72.6855984,33.4853922 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M86.3141053,53.1744363 L71.1712437,53.1744363 C70.7696686,53.1746078 70.3843899,53.015049 70.1003197,52.7309314 C69.8162495,52.4468137 69.6568889,52.0616422 69.6568889,51.6598284 L69.6568889,35 C69.6567173,34.5983578 69.8162495,34.2130147 70.1003197,33.9288971 C70.3843899,33.6447794 70.7694971,33.4853922 71.1712437,33.4853922 L86.3141053,33.4853922 C86.7156803,33.4852206 87.1009591,33.6447794 87.3850292,33.9288971 C87.6690994,34.2130147 87.82846,34.5981863 87.82846,35 L87.82846,51.6598284 C87.8286316,52.0614706 87.6690994,52.4468137 87.3850292,52.7309314 C87.1009591,53.015049 86.7158519,53.1746078 86.3141053,53.1744363 Z M72.6855984,50.1453922 L84.799922,50.1453922 L84.799922,36.5146078 L72.6855984,36.5146078 L72.6855984,50.1453922 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M86.3141053,69.8342647 L71.1712437,69.8342647 C70.7696686,69.8344363 70.3843899,69.6748775 70.1003197,69.3907598 C69.8162495,69.1066422 69.6568889,68.7214706 69.6568889,68.3196569 L69.6568889,51.6598284 C69.6567173,51.2581863 69.8162495,50.8728431 70.1003197,50.5887255 C70.3843899,50.3046078 70.7694971,50.1452206 71.1712437,50.1452206 L86.3141053,50.1452206 C86.7156803,50.145049 87.1009591,50.3046078 87.3850292,50.5887255 C87.6690994,50.8728431 87.82846,51.2580147 87.82846,51.6598284 L87.82846,68.3196569 C87.8286316,68.721299 87.6690994,69.1066422 87.3850292,69.3907598 C87.1009591,69.6748775 86.7158519,69.8344363 86.3141053,69.8342647 Z M72.6855984,66.8052206 L84.799922,66.8052206 L84.799922,53.1744363 L72.6855984,53.1744363 L72.6855984,66.8052206 Z",
  id: "Shape"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "88px",
    height: "70px",
    viewBox: "0 0 88 70",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/Upload__Icon--video.8ef8f235.svg";
export { SvgComponent as ReactComponent };